import { render, staticRenderFns } from "./addbarriergate.vue?vue&type=template&id=59c86ab4&"
import script from "./addbarriergate.vue?vue&type=script&lang=js&"
export * from "./addbarriergate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports